// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","App-logo":"App_App-logo__ZBdRO","App-logo-spin":"App_App-logo-spin__t6jjo","App-header":"App_App-header__qcT6T","App-link":"App_App-link__UIqvc"};